import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="attandances--photo-nav"
//
// Handles navigation to the 現場写真 (site photos) page from the attendance
// screen and warms the service-worker cache for that page while online.
export default class extends Controller {
  static values = {
    photosUrl: String
  }

  connect() {
    this.#prefetchPhotosPage()
  }

  // Warms the service worker cache for the photos page while online so users
  // who later go offline can still navigate there. We hit the no-param URL —
  // the SW falls back to this entry via ignoreSearch for any query variant.
  #prefetchPhotosPage() {
    if (!navigator.onLine) return
    if (!this.hasPhotosUrlValue || !this.photosUrlValue) return
    fetch(this.photosUrlValue, { credentials: "same-origin" }).catch(() => {})
  }

  openPhotos(event) {
    event?.preventDefault()
    if (!this.hasPhotosUrlValue || !this.photosUrlValue) return

    const mode = document.querySelector('input[name="mode"]')?.value || "individual"
    const url = new URL(this.photosUrlValue, window.location.origin)
    url.searchParams.set("mode", mode)

    const workerIds = []
    if (mode === "group") {
      document.querySelectorAll(".member-checkbox:checked").forEach(cb => {
        url.searchParams.append("worker_ids[]", cb.value)
        workerIds.push(cb.value)
      })
    }

    // Stash context so the photos page can recover it even when SW returns a
    // cached HTML rendered with different mode/worker_ids (offline scenario).
    try {
      sessionStorage.setItem("photo_nav_mode", mode)
      sessionStorage.setItem("photo_nav_worker_ids", JSON.stringify(workerIds))
    } catch (e) { /* sessionStorage may be unavailable */ }

    window.location.href = url.toString()
  }
}
